<template>

  <div class="container">

    <div class="handle-box-search">



      <el-button type="primary" icon="el-icon-search" @click="searchmerchantsLists">搜索</el-button>
      <el-button @click="addMerchants_show = !addMerchants_show">添加</el-button>
      <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

    </div>

    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">



      <el-table-column prop="appid" label="APP唯一标识">
      </el-table-column>

      <el-table-column prop="api_key" label="API密钥">
      </el-table-column>

      <el-table-column prop="appsecret" label="APPID接口密码">
      </el-table-column>



      <el-table-column prop="status.alias" label="状态">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status.val=='0'?'warning':(scope.row.status.val=='1'?'':'danger')">
            {{scope.row.status.alias}}</el-tag>
        </template>
      </el-table-column>



      <el-table-column prop="time.YmdHis" label="详细时间">
      </el-table-column>

      <el-table-column label="操作" width="150">
        <template slot-scope="scope">

          <el-dropdown split-button type="primary"
            @click="editMerchants_show = !editMerchants_show; editMerchants_data = scope.row.wx_merchants_code; " trigger="click">

            编辑

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item @click.native="delMerchants(scope.row.wx_merchants_code)">删除</el-dropdown-item>

            </el-dropdown-menu>

          </el-dropdown>

        </template>
      </el-table-column>

    </el-table>

    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>



    <!-- 添加组件 -->
    <addWechat :isShow="addMerchants_show" @onSubmit="merchantsLists"></addWechat>



    <!-- 编辑组件 -->
    <editWechat :isShow="editMerchants_show" @onSubmit="merchantsLists" :data="editMerchants_data"></editWechat>

  </div>

</template>

<script>
  var _this;
  import addWechat from './addWechat.vue';
  import editWechat from './editWechat.vue';
  export default {

    components: {
      addWechat,
      editWechat
    },

    data() {
      return {



        addMerchants_show: false,
        editMerchants_show:false,
        editMerchants_data:'',




        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.merchantsLists();
    },

    methods: {

      delMerchants(code) {

        _this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {

          confirmButtonText: '确定',

          cancelButtonText: '取消',

          type: 'warning',

        }).then(() => {

          _this.$post(
            "/wechat/delMerchantsSubmit", {
              wx_merchants_code: code
            }
          )
          .then(res => {


            _this.$message.success(res.msg);
            _this.merchantsLists();

          }).catch((err) => {

          })

        }).catch(() => {

          _this.$message({
            message: '已取消删除',
            duration: 1500
          });

        });







      },




      searchmerchantsLists() {

        _this.search_data.page = 1;
        _this.merchantsLists();

      },


      merchantsLists() {
        _this.$post(
            "/Wechat/merchantsLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {


            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.merchantsLists();

      },


      // 刷新按钮
      refresh() {
        this.$router.go(0);
      },

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }

  .el-form-item.el-form-item--small {
    width: 100%;
  }

  .demo-table-expand {
    font-size: 0;
  }

  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
  }

  .el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
  }
</style>